import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";
import ProductGridCard from "@/components/feature/ProductGridCard";
import { productById } from "@/mocks/products";
import type { Product } from "@/types";

const selectionIds = [
  "blusa-essencial-sofia",
  "calca-alfaiataria-helena",
  "vestido-midi-serena",
  "macacao-elegancia",
  "bermuda-linho-aurora",
  "conjunto-iris",
  "saia-midi-elisa",
  "vestido-floral-manuela",
  "blusa-romantica-clara",
  "calca-pantalona-valentina",
  "macacao-leve-marina",
  "conjunto-casual-luna",
];

export default function Selection() {
  const items = selectionIds
    .map((id) => productById(id))
    .filter((product): product is Product => Boolean(product));

  return (
    <section id="selecao" className="w-full scroll-mt-24 bg-background-100" aria-label="Seleção Amora Belle">
      <div className="px-4 py-16 md:px-8 md:py-24">
        <div className="mx-auto max-w-7xl">
          <SectionHeading
            eyebrow="Vitrine"
            title="Seleção Amora Belle"
            text="Uma amostra carinhosa das nossas peças favoritas. Toque em “Ver detalhes” para escolher cor, tamanho e adicionar à sacola."
          />

          <div
            data-product-shop
            className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6"
          >
            {items.map((product, index) => (
              <Reveal key={product.id} delay={(index % 3) * 80}>
                <ProductGridCard product={product} />
              </Reveal>
            ))}
          </div>

          <div className="mt-12 flex justify-center">
            <Link
              to="/novidades"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-7 py-3.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-50"
            >
              Ver todas as novidades
              <i className="ri-arrow-right-line text-base" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}